import React, { FC, ComponentProps } from 'react';
import { Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';

type Props = ComponentProps<typeof Button> & {
  label?: string; // Allow for an optional label
};

const ButtonNewCollection: FC<Props> = (props) => {
  const { label, className, ...rest } = props;

  return (
    <Button
      {...rest}
      className={`${className || ''} ${label ? 'rounded-pill' : 'btn-circle'}`}
      variant="primary"
      onClick={props.onClick}
      title="Νέα Συλλογή"
      size={props.size || 'sm'}
      style={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <FaPlus className="me-2" />
      {label ?? ''}
    </Button>
  );
};

export default React.memo(ButtonNewCollection);
